import Image from 'next/image';
import React from 'react';

const AnotherErrorPage = () => {
    return (
        <>
            <section className="hero technology-herosection h-screen">
                <div className="container lg:container md:mx-auto top-hero">
                    <div className="text-center lg:w-6/12 mx-auto">
                        <Image
                            src="/img/img-internal-server-error@2x.webp"
                            alt="500"
                            title="500"
                            height="415"
                            width="460"
                            loading="lazy"
                            className="mb-4 mt-14 img-fluid"
                        />
                        <h1 className="fs-xl mb-4 dark:text-textcolor">Internal Server Error</h1>
                        <p className="fs-md text-black mb-0">The Server has been deserted for a while.</p>
                        <p className="fs-md text-black mb-0">Please be patient or try again later.</p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AnotherErrorPage;
